import React, {Component} from 'react';
import CircularProgress from 'material-ui/CircularProgress';
import FormWrapper from '../../containers/Forms/FormWrapper';
import FormVerificationCode from '../../containers/Forms/FormVerificationCode';
import {entityNames} from '../../config/constants';
import styles from "../Forms/styles";
import {VERIFICATION_DIALOG_TYPE} from "../Forms/FormUserProfile/FormUserProfileDetails";

class VerificationStep2 extends Component {
  UNSAFE_componentWillMount() {
    this.props.setVerificationMethod(this.props.type);
  }

  render() {
    const isEmail = this.props.type === VERIFICATION_DIALOG_TYPE.email;
    const isEnable2fa = this.props.type === VERIFICATION_DIALOG_TYPE.enable2FA;
    const isDisable2fa = this.props.type === VERIFICATION_DIALOG_TYPE.disable2FA;

    const { timer, onResendCode, decrementWizardStep, t } = this.props;

    const resendSection = (isEnable2fa || isDisable2fa) ? (
      <div className="verification-resend-row">
        <p>{t('verification:didntReceiveCode')}</p>
        <div className="verification-resend-action">
          {timer ? (
            <span className="verification-resend-disabled">
              {t('verification:sendAnotherCode')}
            </span>
          ) : (
            <button type="button" className="link-button" onClick={onResendCode}>
              {t('verification:sendAnotherCode')}
            </button>
          )}
          {timer ? (
            <div className="verification-code-timer">
              <CircularProgress
                size={20}
                value={Math.round(100 * timer / 30)}
                mode={'determinate'}
              />
            </div>
          ) : null}
        </div>
      </div>
    ) : (
      <div className="verification-resend-row">
        <p>{t('verification:needVerificationCode')}</p>
        <button
          type="button"
          className="link-button"
          onClick={() => decrementWizardStep(2)}
        >
          {t('verification:getOneHere')}
        </button>
      </div>
    );

    return isEmail ? (
      <div className="verification-dialog-body">
        <h3>{t('verification:checkYourEmail')}</h3>
        <div style={{marginBottom: 20}}>
          {t('verification:weSentYouLink')}
        </div>
        <div className="verification-resend-row">
          <p>Need another verification email?</p>
          <div className="verification-resend-action">
            {timer ? (
              <span className="verification-resend-disabled">
                Send another
              </span>
            ) : (
              <button type="button" className="link-button" onClick={onResendCode}>
                Send another
              </button>
            )}
            {timer ? (
              <div className="verification-code-timer">
                <CircularProgress
                  size={20}
                  value={Math.round(100 * timer / 30)}
                  mode={'determinate'}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>
    ) : (isEnable2fa || isDisable2fa) ? (
      <div className="verification-dialog-body">
        <h3>{t('verification:verify2fa')}</h3>
        <div style={{marginBottom: 20}}>
          {t('verification:weSentYouLConfirmationCode2fa', {
            enabled: isEnable2fa ? 'enabled' : 'disabled'
          })}
        </div>
        {this.props.errors && (
          <div style={{marginTop: 12}}>
            <div style={styles.formError} className="form-error">
              {this.props.errors}
            </div>
          </div>
        )}

        <FormWrapper
          entityName={
            isEnable2fa
              ? entityNames.VERIFICATION_ENABLE_2FA_CODE_BACK
              : entityNames.VERIFICATION_DISABLE_2FA_CODE_BACK
          }
          entity={['verificationMethod', 'code']}
          noValidation={true}
          onSubmit={(data, entityName) =>
            this.props.onVerifyCode(
              data,
              entityName,
              isDisable2fa,
            )
          }
        >
          <FormVerificationCode/>
        </FormWrapper>
        {resendSection}
      </div>
    ) : (
      <div className="verification-dialog-body">
        <h3>{t('verification:enterVerificationCode')}</h3>
        <div style={{marginBottom: 20}}>
          {t('verification:enterCodeWeSent')}
        </div>
        <FormWrapper
          entityName={entityNames.VERIFY_PHONE_VERIFICATION_CODE}
          entity={['verificationMethod', 'code']}
          onSubmit={this.props.onVerifyCode}
        >
          <FormVerificationCode/>
        </FormWrapper>
        {resendSection}
      </div>
    );
  }
}

export default VerificationStep2;
